Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _images = require("../../images");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    viewports = _STYLES$useStyles.viewports,
    spacing = _STYLES$useStyles.spacing,
    colors = _STYLES$useStyles.colors,
    COLORS = _STYLES$useStyles.COLORS,
    fontBold = _STYLES$useStyles.fontBold,
    fontRegular = _STYLES$useStyles.fontRegular;
  var container = {
    padding: spacing.normal,
    width: '100%',
    borderRadius: (0, _styles.getREM)(0.625),
    flexShrink: 1,
    borderColor: colors.border,
    borderWidth: 1,
    backgroundColor: COLORS.lavenderBlush,
    paddingVertical: spacing.m
  };
  if (bp.gt(viewports.mobile_l)) {
    container.paddingHorizontal = spacing.l;
  }
  var textContainer = {
    marginBottom: spacing.l
  };
  var title = Object.assign({}, fontBold, {
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.l,
    lineHeight: _styles.STYLES.lineHeight.l,
    marginBottom: spacing.m
  });
  var text = Object.assign({}, fontRegular, {
    color: colors.text,
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal
  });
  var row = {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  };
  var illustration = {
    height: 190 * _images.ShoeRedCheckmarkHeightRatio,
    width: 190,
    display: 'none',
    alignSelf: 'center',
    marginTop: -40
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    illustration.display = 'flex';
  }
  var buttonContainer = {
    flex: 1
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    textContainer: textContainer,
    row: row,
    title: title,
    text: text,
    illustration: illustration,
    buttonContainer: buttonContainer
  });
  return {
    styles: styles
  };
};